/* @flow */

export const validation = {
  paragraphMaxChar: 120,
  contentImage: 1,
  paragraph: { required: true }
}